module.exports = __webpack_public_path__ + "img/SendPulse.a259a4de.svg";